/**
 * Standort-Umschalter (Phase 2.11) – nur bei ≥2 Einträgen in Stammdaten.
 */
import { useEffect } from 'react';
import { Select } from '@mantine/core';
import { IconMapPin } from '@tabler/icons-react';
import { useCustomerStore } from '../../stores/customerStore';

export function PortalLocationFilter() {
  const contact = useCustomerStore((s) => s.contact);
  const selectedCwSiteId = useCustomerStore((s) => s.selectedCwSiteId);
  const setSelectedCwSiteId = useCustomerStore((s) => s.setSelectedCwSiteId);

  if (!contact?.locationFilterAvailable || !contact.portalLocationOptions?.length) {
    return null;
  }

  const opts = contact.portalLocationOptions;

  useEffect(() => {
    const o = contact.portalLocationOptions;
    if (!o?.length || selectedCwSiteId == null) return;
    if (!o.some((x) => x.cwSiteId === selectedCwSiteId)) setSelectedCwSiteId(null);
  }, [contact, selectedCwSiteId, setSelectedCwSiteId]);
  const data = [
    { value: '', label: 'Alle Standorte' },
    ...opts.map((o) => ({ value: String(o.cwSiteId), label: o.label })),
  ];

  return (
    <Select
      size="xs"
      w={200}
      leftSection={<IconMapPin size={14} />}
      aria-label="Standort filtern"
      placeholder="Standort"
      data={data}
      value={selectedCwSiteId != null ? String(selectedCwSiteId) : ''}
      onChange={(v) => setSelectedCwSiteId(v && v !== '' ? Number(v) : null)}
      clearable={false}
    />
  );
}
